import React from 'react'

function CommunityAgreementEN() {
  return (
    <>
      <p className="heading-1">
        Transfer of rights Contact for Content created by the Creator
      </p>

      <div className="paragraph-2">
        <p>
          Skeepers is a simplified joint-stock company with a capital of
          11,470,723 euros, registered with the Marseille Trade and Companies
          Register under number 879 038 990, whose registered office is located
          at 18-20 Avenue Robert Schuman, CS 40494, 13002 Marseille.
        </p>
        <p>
          In this Agreement, "Skeepers" means Skeepers and its affiliates. All
          terms beginning with a capital letter are defined in the Skeepers
          T&Cs.
        </p>
        <p>
          By posting content on the Site, you acknowledge and expressly agree to
          assign to Skeepers, under the conditions defined below, all rights
          held by you to the Content you have created (in accordance with the
          Skeepers T&Cs, the term "Content" means the texts, images,
          photographs, drawings, avatars, and, more generally, any visual,
          textual, sound or graphic publication of the Creator, representing the
          Products, distributed within the framework of the services), and
          expressly authorize Skeepers to use your image under the conditions
          specified below:
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          1. Assignment of Content Rights
        </p>
        <p>
          In return for ownership of the Product received, you expressly and
          non-exclusively assign to Skeepers all of the rights you hold to the
          Content, including the right for Skeepers:
        </p>
        <ul className="paragraph-2">
          <li>
            to use, reproduce, sublicense, assign, distribute, fix temporarily
            or not, disseminate, put into circulation, extract, download, store,
            list, classify in a database, communicate to the public, represent,
            exploit the Content on all formats and on all media known or unknown
            to date and in particular without this list being of a limiting
            nature, on the internet and whatever the generic, geographical
            suffix or the extension of the name of domain of the website
            concerned and the country in which the Content is received (in
            particular on the Skeepers platform and website, on its social
            networks such as Facebook, Twitter, Instagram, IGTV, Snapchat, on
            sites for sharing audiovisual recordings such as YouTube,
            Dailymotion, Pinterest, but also Weibo, WeChat, and, in general, on
            any other existing or future medium), by any form of distribution
            such as cinema, terrestrial television, satellite, cable provider by
            TNT and by any existing or future process, in France and abroad;
          </li>
          <li>
            to make any total or partial modification to the Content, such as
            addition, deletion, adaptation, translation, variation, editing and
            dubbing in a language other than French, to carry out any extraction
            of all or part of the Content for global use and on any appropriate
            operating mode and on any medium. The transferred Content may also
            be adapted and/or translated to enable its integration into another
            audiovisual, multimedia and/or digital work and on all the media
            defined above;
          </li>
          <li>
            to grant all or part of the rights that you transfer to it under the
            terms of this contract. In particular, the right to represent and
            distribute your Content may be granted, through a sublicense, on all
            media and in all formats and in particular:
            <ul className="paragraph-2">
              <li>
                on the Internet (in particular on the Customer's website and/or
                social networks, such as Facebook, Twitter, Instagram, IGTV,
                Snapchat, on audiovisual recording sharing sites such as YouTube
                Dailymotion, Pinterest, but also, Weibo, WeChat, and, in
                general, on any other existing or future media), by any form of
                distribution such as cinema, terrestrial television, by
                satellite, by cable operator, by TNT and by any existing or
                future process, in France and abroad, on the e-commerce site(s)
                on which the Customer offers his products for sale, whether or
                not he is publisher of this e-commerce site(s) regardless of the
                generic, geographical suffix or the extension of the domain name
                of the Customer's website, and the country receiving the
                Content;
              </li>
              <li>
                at the Customer's physical sale locations (stores, corners), at
                fairs, exhibitions, physical places of advertising, exhibitions
                and all other public events where the Customer will be present
                or represented;
              </li>
              <li>
                internally for the benefit of the Client's members and
                employees.
              </li>
            </ul>
          </li>
        </ul>
        <p>
          This assignment allows Skeepers to use said Content both for external
          and internal communication purposes, as well as for free, promotional,
          advertising, events, commercial and lucrative purposes, in particular
          by the marketing and/or availability to its Customers, directly or
          through third parties authorized by Skeepers, of products or services.
        </p>
        <p>
          This transfer of rights is granted from the day of your acceptance of
          this contract and for the legal duration of protection of rights. This
          transfer is granted worldwide.
        </p>
        <p>
          With respect to your moral rights, the right to adapt the Content will
          allow Skeepers to make changes to the Content, such as any
          modification made necessary due to technical constraints or to allow
          the implementation of the Content in any form and on any medium chosen
          by Skeepers on which the Content will be reproduced or represented.
          You refrain from opposing or challenging these changes, but also from
          claiming any compensation or remuneration whatsoever for these changes
          to the extent that the integrity of your work is respected.
        </p>
        <p>
          You represent and warrant to Skeepers that you are the exclusive owner
          of all rights assigned for the Content under this agreement. You
          therefore guarantee that you have obtained from any authors and/or
          assistants who have intervened in the context of the production of the
          Content and who may benefit from any rights to be asserted on the
          Content, all the rights and authorizations necessary allowing you to
          transfer the rights of ownership attached to the Content for the
          benefit of Skeepers, and in particular the rights to use the music
          attached to your Content if applicable.
        </p>
        <p>
          You also declare that the rights have not been the subject of any
          partial or total transfer, free of charge or against payment, of any
          operating license of any kind whatsoever, of any pledge, or of any
          right of pledge, to anyone, or any dispute in any form whatsoever,
          with the exception of the license granted to the social network on
          which you posted the Content.
        </p>
        <p>
          You guarantee the peaceful enjoyment of these rights and you undertake
          to indemnify Skeepers against all consequences, in particular
          financial, which could result from any dispute, claim or action
          brought by a third party relating to the ownership of the rights to
          the Content.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">2. Image rights</p>
        <p>
          Insofar as you appear in the Content, you expressly authorize Skeepers
          to use the attributes of your personality (including image, personal
          brand, personal logo, last name, first name and voice) in order to
          allow Skeepers to exercise the rights granted to it on the Content in
          accordance with point 1 above.
        </p>
        <p>
          In return for ownership of the Product received, you expressly
          authorize Skeepers:
        </p>
        <ul className="paragraph-2">
          <li>
            to capture, fix, reproduce, adapt and distribute your image
            (including, in particular, your image, personal brand, personal
            logo, voice, last name and first name) on all the fixation,
            reproduction and distribution media mentioned in point 1) above, and
            in particular on the internet, on the Skeepers platform and site, on
            its social networks such as Facebook, Twitter, Instagram, IGTV,
            Snapchat, on audiovisual sharing sites such as YouTube Dailymotion,
            Pinterest, but also Weibo, WeChat, and, in general, on any other
            existing or future medium), by any form of broadcasting such as
            cinema, terrestrial television, by satellite, by cable operator, by
            TNT and by any existing or future process, in France and abroad,
            whatever the generic suffix, geographical location or the extension
            of the domain name of the website concerned and the country of
            receipt of the Content;
          </li>
          <li>
            to grant to its beneficiaries (in particular manufacturers,
            distributors, merchant websites, and more generally its professional
            customers, etc.) the right under license to use the attributes of
            your personality (in particular image, personal brand, personal
            logo, last name, first name and voice) on the Internet (in
            particular on website and/or social networks, such as Facebook,
            Twitter, Instagram, IGTV, Snapchat, on audiovisual sharing sites
            such as YouTube, Dailymotion, Pinterest, but also Weibo, WeChat,
            and, in general, on any other existing or future medium), by any
            form of broadcasting such as cinema, terrestrial television, by
            satellite, by cable operator, by TNT and by any existing or future
            process, in France and abroad, on the e-commerce site(s) on which
            the Customer offers its products for sale, whether or not they are
            the publisher of this (these) e-commerce site(s) and regardless of
            the generic or geographical suffix or extension of the domain name
            of the Customer's website, and the country receiving the Content, on
            the Customer's physical points of sale (stores, corners), at fairs,
            shows, exhibitions, physical places of advertising and all other
            public events where the Customer will be present or represented and
            internally for the benefit of the members and employees of the
            Customer.
          </li>
        </ul>
        <p>
          This authorization is granted worldwide and for a period of twenty
          (20) years from the date of your acceptance of this contract.
        </p>
        <p>
          You declare and guarantee that you have obtained the written agreement
          of the persons represented in the Content, or their legal
          representatives, for the use of their personal attributes (in
          particular image, name, voice) so that the Content can be freely used,
          disseminated, reproduced and used by Skeepers and its Customer under
          the conditions stipulated herein. You undertake to support this
          authorization, without delay, on first request by Skeepers. You agree
          to indemnify Skeepers against any consequences that may result from
          any dispute, claim or action brought by a third party relating to the
          use of their personal attributes.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">3. Common provisions</p>
        <p>
          The transfer of your rights to the Content in accordance with point 1)
          and the authorization to use your image granted in accordance with
          point 2) is approved for the exploitation, operation and institutional
          and advertising promotion by Skeepers of its site, its platform and
          its activities as well as the institutional and advertising promotion
          of the products, services and activities of its beneficiaries (in
          particular manufacturers, distributors, merchant websites, and more
          generally its professional customers, etc.).
        </p>
        <p>
          In accordance with article L.122-7 of the Intellectual Property Code,
          you expressly acknowledge and accept that this transfer of rights and
          authorization to use your image is granted only in return for the
          product received. You waive any right to claim any other form of
          consideration, including financial.
        </p>
        <p>
          In the event that at the time of acceptance of this contract, you are
          a minor (under the age of 18), you declare and guarantee to Skeepers
          that you have obtained the authorization of your parents or the
          holder(s) of the parental authority, or, failing that, of your legal
          guardian(s), to accept this contract. You undertake to support this
          authorization, without delay, on first request by Skeepers.
        </p>
        <p>
          In the event of any contradiction between this contract and the
          general terms and conditions of use of the Skeepers site and platform,
          the provisions of this contract shall prevail.
        </p>
        <p>
          In the event of cancellation by a court or any other competent
          authority of one of the clauses of this contract, all the other
          clauses of this contract will remain in force unless, because of the
          cancellation of the clause, these become irrelevant or impossible to
          perform.
        </p>
        <p>This agreement is subject to French law.</p>
        <p>
          No tolerance on the part of Skeepers, regardless of its nature,
          extent, duration or frequency, may be considered as creating any right
          for your benefit or be interpreted as a waiver on its part of any of
          the provisions of this contract.
        </p>
        <p>
          By express agreement, the e-mails and automatic registration systems
          used on the Skeepers site and platform will prevail between the
          parties.
        </p>
      </div>
    </>
  )
}

export default CommunityAgreementEN
